export const FETCH_NAV = 'FETCH_NAV'
export const SET_NAV = 'SET_NAV'
export const UPDATE_NAV = 'UPDATE_NAV'
export const NAV_SUCCESS = 'NAV_SUCCESS'
export const NAV_ERROR = 'NAV_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/navigation/nav.type.js